import { Profil } from "../Api/swagger";

export const isPathAuthorizedForUser = (
  path?: string,
  profil?: Profil,
  refBien?: string,
  statutDossier?: string
): boolean => {
  if (profil && !profil.fonctions?.find((f) => f === "FRONT_LECTURE")) {
    return false;
  } else if (path && path.startsWith("/dashboard")) {
    return true;
  } else if (profil && profil.fonctions) {
    if (
      path &&
      path.startsWith("/mes-administrateurs-de-biens") &&
      profil.fonctions.find((f) => f === "PRMDRTADB_LECTURE")
    ) {
      return true;
    } else if (
      path &&
      path === "/mes-utilisateurs" &&
      (profil.fonctions.find((f) => f === "PRMUTIBC_LECTURE") ||
        profil.fonctions.find((f) => f === "PRMUTIADB_LECTURE"))
    ) {
      return true;
    } else if (
      ((path && path === "/mes-utilisateurs/ajouter") ||
        path === "/mes-utilisateurs/modifier") &&
      profil.fonctions.find((f) => f === "PRMUTIADB_ECRITURE")
    ) {
      return true;
    } else if (
      ((path && path === "/mes-utilisateurs/modifierBesse") ||
        path === "/mes-utilisateurs/ajouterBesse") &&
      profil.fonctions.find((f) => f === "PRMUTIBC_ECRITURE")
    ) {
      return true;
    } else if (
      path &&
      path.startsWith("/dossier-location") &&
      (profil.fonctions.find((f) => f === "TDBDOSLOC_MODIFICATION_MIENS") ||
        profil.fonctions.find((f) => f === "TDBDOSLOC_MODIFICATION_TOUS"))
    ) {
      if (
        ((path && path.startsWith("/dossier-location/situation-personnelle")) ||
          path.startsWith("/dossier-location/situation-professionnelle")) &&
        (!refBien || (statutDossier && statutDossier === "NON_VALIDE"))
      ) {
        return false;
      }
      return true;
    } else if (
      path &&
      path.startsWith("/messages") &&
      profil.fonctions.find((f) => f === "ENCART_ECRITURE")
    ) {
      return true;
    }
  }
  return false;
};
